import { IonItem } from '@ionic/react'
import './dividerLine.css'

const DividerLine = () => {
  return <IonItem className="DividerLine" lines="full" />
}

export default DividerLine
